import { BaseAlgorithmTuner } from './BaseTuner';
import * as DT from '../DataTypes';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';

export class IdentifiersListTuner extends BaseAlgorithmTuner<string, DT.StringT> {
  public constructor(planningAlgorithm: PlanningAlgorithm) {
    super(planningAlgorithm, DT.StringT);
  }

  public getListName(name: string): string {
    return name + '.list';
  }

  public getValuesList(name: string): Array<string> {
    return this._planningAlgorithm.getValueStrict(this.getListName(name), DT.IdentifiersList).value;
  }
}
